import { render, staticRenderFns } from "./MilestonesNavigation.vue?vue&type=template&id=08c08407&scoped=true&"
import script from "./MilestonesNavigation.vue?vue&type=script&lang=js&"
export * from "./MilestonesNavigation.vue?vue&type=script&lang=js&"
import style0 from "./MilestonesNavigation.vue?vue&type=style&index=0&id=08c08407&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c08407",
  null
  
)

export default component.exports